export default __webpack_public_path__ + "static/media/Group8394.09267b50.svg";